import { AxiosPost, AxiosGet } from "../AxiosWrapper";
import { MANAGEMENT_SERVICE_URL } from "../../constants/ServiceUrls";

export const changePassword = (params) => {
  return AxiosPost(`${MANAGEMENT_SERVICE_URL}api/UserProfile/ChangePassword`, {
    ...params,
  });
};

export const getUserProfile = () => {
  return AxiosGet(`${MANAGEMENT_SERVICE_URL}api/UserProfile/GetUserProfile`);
};

export const updateUserProfile = (params) => {
  let parms = params;
  if (parms.phoneNumber === null) {
    parms.phoneNumber = "";
  }
  if (parms.location === null) {
    parms.location = "";
  }
  if (parms.department === null) {
    parms.department = "";
  }
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/UserProfile/UpsertUserProfile`,
    {
      ...params,
    }
  );
};

export const contactUs = (formData) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/UserProfile/ContactUs`,

    formData
  );
};

export const resetPassword = (Email) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/UserProfile/ResetPassword`,
    Email
  );
};

export const getNotifications = () => {
  return AxiosGet(`${MANAGEMENT_SERVICE_URL}api/UserProfile/GetNotifications`);
};

export const deleteNotifications = (notificationIds) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/UserProfile/DeleteNotifications`,
    { notificationIds }
  );
};

export const switchClient = (clientId) => {
  return AxiosPost(`${MANAGEMENT_SERVICE_URL}api/UserProfile/SwitchClient`, {
    clientId,
  });
};

export const updateDocumentViewPreference = (
  updateDocumentViewPreferenceParameters
) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/UserProfile/UpdateDocumentViewPreference`,
    updateDocumentViewPreferenceParameters
  );
};

export const getDocumentViewPreference = () => {
  return AxiosGet(
    `${MANAGEMENT_SERVICE_URL}api/UserProfile/GetDocumentViewPreference`
  );
};

export const generateOneTimePasswordSecret = (
  generateOneTimePasswordSecretParameters
) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/UserProfile/GenerateOneTimePasswordSecret`,
    generateOneTimePasswordSecretParameters
  );
};

export const deleteOneTimePasswordSecret = () => {
  return AxiosGet(
    `${MANAGEMENT_SERVICE_URL}api/UserProfile/DeleteOneTimePasswordSecret`
  );
};

export const validateOneTimePasswordConfiguration = (
  validateOneTimePasswordConfigurationParameters
) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/UserProfile/ValidateOneTimePasswordConfiguration`,
    validateOneTimePasswordConfigurationParameters
  );
};

export default {
  updateDocumentViewPreference,
  getDocumentViewPreference,
};
